import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Menu, X, Instagram } from 'lucide-react';
import { NAV_LINKS, INSTAGRAM_URL } from './data';

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <motion.header
      data-testid="navbar"
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
      className={`fixed top-0 left-0 right-0 z-50 border-b transition-colors duration-300 ${
        scrolled ? 'bg-ink/85 backdrop-blur-xl border-white/10' : 'bg-transparent border-transparent'
      }`}
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 flex items-center justify-between h-16 sm:h-20">
        <button
          data-testid="nav-logo"
          onClick={() => go('#hero')}
          className="flex items-center hover:opacity-80 transition-opacity"
          aria-label="Alfredj inicio"
        >
          <img
            src={`${process.env.PUBLIC_URL}/alfredj-logo.png`}
            alt="Alfredj"
            className="h-12 sm:h-14 w-auto object-contain"
          />
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-link-${l.href.replace('#', '')}`}
              onClick={() => go(l.href)}
              className="text-sm uppercase tracking-widest text-[#f1f0ea]/70 hover:text-acid transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          data-testid="nav-cta"
          onClick={() => go('#contacto')}
          className="hidden md:inline-block bg-acid text-white font-heading uppercase text-sm px-6 py-3 hover:-translate-y-0.5 hover:shadow-[4px_4px_0px_#f1f0ea] transition-all duration-200"
        >
          Reservar Fecha
        </button>

        <a
          data-testid="nav-instagram"
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram de Alfredj"
          className="hidden md:flex items-center justify-center h-11 w-11 border border-white/15 text-[#f1f0ea] hover:border-acid hover:text-acid transition-colors"
        >
          <Instagram size={20} />
        </a>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="md:hidden text-[#f1f0ea] p-2"
          aria-label="Menú"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          data-testid="mobile-menu"
          className="md:hidden bg-ink border-t border-white/10 px-5 py-6 flex flex-col gap-5"
        >
          {NAV_LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`mobile-nav-link-${l.href.replace('#', '')}`}
              onClick={() => go(l.href)}
              className="text-left font-heading text-2xl uppercase text-[#f1f0ea] hover:text-acid transition-colors"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="mobile-nav-cta"
            onClick={() => go('#contacto')}
            className="mt-2 bg-acid text-white font-heading uppercase text-lg px-6 py-4"
          >
            Reservar Fecha
          </button>
          <a
            data-testid="mobile-nav-instagram"
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 font-heading uppercase text-lg text-[#f1f0ea] hover:text-acid transition-colors"
          >
            <Instagram size={22} /> Instagram
          </a>
        </motion.div>
      )}
    </motion.header>
  );
};
